/** A jel: sötétkék kontúros háromszög, benne „AI" (a borító motívuma) + wordmark. */
export function Mark({ size = 28 }: { size?: number }) {
  const h = Math.round((size * 26) / 28);
  return (
    <svg width={size} height={h} viewBox="0 0 28 26" aria-hidden="true">
      <path d="M14 2 26 24H2z" fill="none" stroke="#14192E" strokeWidth="2" />
      <text
        x="14"
        y="21"
        textAnchor="middle"
        fontFamily="Archivo, Helvetica, Arial, sans-serif"
        fontWeight="800"
        fontSize="10"
        fill="#14192E"
      >
        AI
      </text>
    </svg>
  );
}

/** A cím két sorban, a borító sortörésével — így az oldalsávokba (224–240 px) is befér; a
 *  sorok nem törhetnek tovább. A `sub` a második sor: alapból „Digitális melléklet",
 *  az adminban „Admin". */
export function Wordmark({ sub = "Digitális melléklet" }: { sub?: string }) {
  return (
    <div className="flex flex-col leading-tight">
      <span className="whitespace-nowrap text-[13px] font-extrabold uppercase leading-[1.15] tracking-[0.08em] text-gold-text">
        Tudatos ember
        <br />
        az AI korában
      </span>
      <span className="text-[11px] font-medium text-muted">{sub}</span>
    </div>
  );
}

export function Brand({ size = 28, sub }: { size?: number; sub?: string }) {
  return (
    <div className="flex items-center gap-2.5">
      <Mark size={size} />
      <Wordmark sub={sub} />
    </div>
  );
}
